module.exports = __webpack_public_path__ + "img/slide3.a1483c96.jpg";